var _ = require('underscore');
var TorsoListView = require('backbone-torso/modules/ListView');
var AppointmentInsuranceItemView = require('./AppointmentInsuranceItemView');
var appointmentInsuranceListWidgetTemplate = require('./appointmentInsuranceListWidgetTemplate.hbs');
var appointmentInsuranceListWidgetEmptyTemplate = require('./appointmentInsuranceListWidgetEmptyTemplate.hbs');
var AppointmentDataBehavior = require('./../appointment/AppointmentDataBehavior');
var AppointmentTypeDataBehavior = require('./../appointment-type/AppointmentTypeDataBehavior');
var InsurancePolicyDataBehavior = require('./../insurance/InsurancePolicyDataBehavior');
var appointmentConfigurationModel = require('./../appointment-config/appointmentConfigurationModel.js');
var wizardUtils = require('./../wizard/wizardUtils');

 /**
   * This view renders an List of Insurances
   * @class AppointmentInsuranceListWidget
   * @constructor
   * @param options {Object} Options to configure this view.
   *   @param [options.appointmentExternalId] {String} the id of the current appointment being preregistered for
   *   @param [options.viewOnly] {Boolean} whether this widget should be rendered in view only mode
   * @extends Torso.ListView
   */
module.exports = TorsoListView.extend({
  className: 'index index--appointment-insurances',
  itemView: AppointmentInsuranceItemView,
  template: appointmentInsuranceListWidgetTemplate,
  itemContainer: 'insurance-items',
  emptyTemplate: appointmentInsuranceListWidgetEmptyTemplate,

  behaviors: {
    insurancePolicies: {
      behavior: InsurancePolicyDataBehavior,
      alwaysFetch: true,
      renderOnFetch: true,
      ids: function(cache) {
        var criteria = {
          appointmentExternalId: this.view._appointmentExternalId
        };
        if (!this.view._viewOnly) {
          criteria.walletPatientVecnaId = this.view._patientVecnaId;
        }
        return cache.fetchIdsByCriteria(criteria);
      }
    },
    appointment: {
      behavior: AppointmentDataBehavior,
      returnSingleResult: true,
      renderOnFetch: true,
      id: { property: '_appointmentExternalId' }
    },
    appointmentType: {
      behavior: AppointmentTypeDataBehavior,
      returnSingleResult: true,
      renderOnFetch: true,
      ids: { property: 'behaviors.appointment.data:externalAppointment.type'}
    }
  },

  prepareFields: {
    viewOnly: function() {
      return this._viewOnly;
    },
    isMultiAppointment: function() {
      return this._regDate;
    },
    addNewInsurancePageUrl: function() {
      return wizardUtils.getPageUrl({
        hash: 'appointmentPreRegInsuranceEdit',
        appointmentExternalId: this._appointmentExternalId,
        regDate: this._regDate
      });
    },
    appointmentTimeReplacement: function() {
      var appointmentTypeModel = this.getBehavior('appointmentType').data.getModel();
      return appointmentTypeModel && appointmentTypeModel.getEffectiveAppointmentTimeReplacement();
    },
    removeAppointmentTimeDisplay: function() {
      if (appointmentConfigurationModel.isLoading() || !appointmentConfigurationModel.hasLoadedOnce()) {
        return false;
      }
      return appointmentConfigurationModel.get('removeAppointmentTimeDisplay');
    }
  },

  /**
   * @method initialize
   * @param options {Object} Options to configure this view.
   *   @param [options.patientVecnaId] {String} the id of the current appointment being preregistered for
   *   @param [options.appointmentExternalId] {String} the id of the current appointment being preregistered for
   *   @param [options.regDate] {String} the date of the current appointments being preregistered for
   *   @param [options.visitId] {String} the id of the current visit to consider the insurances for.
   *   @param [options.viewOnly] {Boolean} whether this widget should be rendered in view only mode
   *   @param [options.showAllDetails] {Boolean} whether to show all details of the insurances (mainly for admin)
   * @override
   */
  initialize: function(options) {
    var defaultOptions = {
      appointmentExternalId: this.model && this.model.get('appointmentDTO.externalId')
    };
    options = _.extend(defaultOptions, options, options && options.context);
    this._patientVecnaId = options.patientVecnaId;
    this._appointmentExternalId = options.appointmentExternalId;
    this._regDate = options.regDate;
    this._visitId = options.visitId;
    this._viewOnly = options.viewOnly;

    this.__itemContext = {
      patientVecnaId: options.patientVecnaId,
      viewOnly: this._viewOnly,
      appointmentExternalId: this._appointmentExternalId,
      regDate: this._regDate,
      showAllDetails: options.showAllDetails,
      visitId: this._visitId
    };

    var insurancePolicyDataBehavior = this.getBehavior('insurancePolicies');
    this.collection = insurancePolicyDataBehavior.data.privateCollection;
    this.listenTo(appointmentConfigurationModel, 'load-complete', this.render);
    appointmentConfigurationModel.loadOnce();
    this.listenTo(this.collection, 'add reset remove sort', this._triggerInsurancesUpdatedEvent);
    this.listenTo(this.getBehavior('appointment'), 'fetched', this._sortCollection);
    this._sortCollection();
  },

  /**
   * Sorts the insurances by the appointment.
   * @method _sortCollection
   * @private
   */
  _sortCollection: function() {
    var appointmentModel = this.getBehavior('appointment').data.getModel();
    this.collection.setAppointmentToSortBy(appointmentModel);
  },

  /**
   * Trigger 'insurances-updated' event to let any listening views know that the collection of insurances have updated
   * @method _triggerInsurancesUpdatedEvent
   * @override
   * @private
   */
  _triggerInsurancesUpdatedEvent: function() {
    this.trigger('insurances-updated');
    this.getBehavior('insurancePolicies').fetch();
  },

  /**
   * @method hasInsurances
   * @override
   * @returns {Boolean} whether the list view retreived any insurances
   */
  hasInsurances: function() {
    return !!this.collection && this.collection.length > 0;
  },

  /**
   * @method hasUnapprovedUpdates
   * @returns {Boolean} true if there are updates in the collection that have not been approved yet, false otherwise.
   */
  hasUnapprovedUpdates: function() {
    return this.collection.hasUnapprovedUpdates();
  }
});
